export const ItemTypes = {
  HEADER: 'header',
};
